export default __webpack_public_path__ + "static/media/y_3d3e2424.6ee81a93.jpg";